import api from "../api";

const issueTestInvoice = async ({ storeCode, ...payload }) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/management/stores/${encodeURIComponent(
    storeCode
  )}/test-invoices`;
  const response = await api.post(endpoint, payload);
  return response.data;
};

export default issueTestInvoice;
